"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccessCondition = exports.transferOwnership = exports.shareToAddress = exports.accessControl = exports.shardKey = exports.saveShards = exports.recoverKey = exports.revokeAccess = exports.recoverShards = exports.getAuthMessage = exports.getJWT = exports.generate = void 0;
const generate_1 = require("./generate");
Object.defineProperty(exports, "generate", { enumerable: true, get: function () { return generate_1.generate; } });
const getJWT_1 = require("./getJWT");
Object.defineProperty(exports, "getJWT", { enumerable: true, get: function () { return getJWT_1.getJWT; } });
const getAuthMessage_1 = require("./getAuthMessage");
Object.defineProperty(exports, "getAuthMessage", { enumerable: true, get: function () { return getAuthMessage_1.getAuthMessage; } });
const recoverKey_1 = require("./recoverKey");
Object.defineProperty(exports, "recoverKey", { enumerable: true, get: function () { return recoverKey_1.recoverKey; } });
const recoverShards_1 = require("./recoverShards");
Object.defineProperty(exports, "recoverShards", { enumerable: true, get: function () { return recoverShards_1.recoverShards; } });
const saveShards_1 = require("./saveShards");
Object.defineProperty(exports, "saveShards", { enumerable: true, get: function () { return saveShards_1.saveShards; } });
const shardKey_1 = require("./shardKey");
Object.defineProperty(exports, "shardKey", { enumerable: true, get: function () { return shardKey_1.shardKey; } });
const revokeAccess_1 = require("./revokeAccess");
Object.defineProperty(exports, "revokeAccess", { enumerable: true, get: function () { return revokeAccess_1.revokeAccess; } });
const accessControl_1 = require("./accessControl");
Object.defineProperty(exports, "accessControl", { enumerable: true, get: function () { return accessControl_1.accessControl; } });
const shareToAddress_1 = require("./shareToAddress");
Object.defineProperty(exports, "shareToAddress", { enumerable: true, get: function () { return shareToAddress_1.shareToAddress; } });
const transferOwnership_1 = require("./transferOwnership");
Object.defineProperty(exports, "transferOwnership", { enumerable: true, get: function () { return transferOwnership_1.transferOwnership; } });
const getAccessCondition_1 = require("./getAccessCondition");
Object.defineProperty(exports, "getAccessCondition", { enumerable: true, get: function () { return getAccessCondition_1.getAccessCondition; } });
exports.default = {
    generate: generate_1.generate,
    getJWT: getJWT_1.getJWT,
    getAuthMessage: getAuthMessage_1.getAuthMessage,
    recoverShards: recoverShards_1.recoverShards,
    revokeAccess: revokeAccess_1.revokeAccess,
    recoverKey: recoverKey_1.recoverKey,
    saveShards: saveShards_1.saveShards,
    shardKey: shardKey_1.shardKey,
    accessControl: accessControl_1.accessControl,
    shareToAddress: shareToAddress_1.shareToAddress,
    transferOwnership: transferOwnership_1.transferOwnership,
    getAccessCondition: getAccessCondition_1.getAccessCondition
};
